import {createSelector} from "reselect"
import {push} from 'react-router-redux'


export const moduleName = "router"


export const stateSelector = state => state[moduleName]

export const locationSelector = createSelector(stateSelector, state => state.location)

export const pathnameSelector = createSelector(locationSelector, location => location.pathname)


// TODO temp for dev
window.__push = push


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/modules/router.js